// import { useState } from "react";
// import { FaMinus } from "react-icons/fa6";
// import { FaCheck } from "react-icons/fa6";
// import CalvinLogo from "../../../assets/Images/Calvin-Group-Logo.svg";
// import RightIcon from "../../../assets/Images/rightIcon.svg";
// import MachineImg from "../../../assets/Images/machineImg.svg";
// import { useNavigate } from "react-router-dom";

// const Card = ({ listCard }) => {
//   const navigate = useNavigate();
//   // State for the custom checkbox
//   const [checkboxState, setCheckboxState] = useState("not-selected");

//   // Handle checkbox click to cycle through states
//   const handleCheckboxClick = () => {
//     setCheckboxState((prevState) => {
//       if (prevState === "not-selected") return "selected";
//       if (prevState === "selected") return "minus";
//       return "not-selected";
//     });
//   };

//   return (
//     <>
//       <div className="shadow-xl relative">
//         <div
//           onClick={() => {
//             window.scrollTo({
//               top: 0,
//               behavior: "smooth",
//             });
//             navigate("/detail");
//           }}
//           className="cursor-pointer"
//         >
//           <img src={MachineImg} alt="Machine" width="100%" className="object-cover" />
//         </div>

//         <div className="p-[10px]">
//           <div className="text-[#161412] text-[20px] font-bold">2016 Roadtec SB-2500e</div>
//           <div className="text-[#161412] text-[14px] font-normal">Material Transfer Vehicle</div>
//           <div className="text-[#161412] text-[14px] font-medium">2425 Hours</div>
//         </div>

//         <div className="mt-[10px] md:mt-[40px] text-center sm:text-end px-[10px]">
//           <div className="text-[#161412] text-[20px] md:text-[30px] font-bold">$249,500 USD</div>
//         </div>
//         <div
//           className={`flex ${
//             !listCard ? "justify-between" : "justify-end"
//           } items-center px-[10px] pb-[10px] sm:flex-row flex-col`}
//         >
//           {!listCard ? (
//             <div>
//               <img src={CalvinLogo} alt="Calvin Logo" />
//             </div>
//           ) : null}

//           <div className="flex flex-col items-center sm:items-end">
//             <div className="text-[#161412] text-[16px] flex">
//               <img src={RightIcon} alt="Right Icon" className="mr-1" />
//               <b>Calvin Group Inc | </b> Grafton, OH
//             </div>
//             <div className="text-[#161412] text-[16px] font-bold">+1 (800) 888-8888</div>
//             <div className="text-[#161412] text-[16px] font-bold">sales@calvingroupinc.com</div>
//           </div>
//         </div>

//         {/* Custom Checkbox */}
//         <div className="flex justify-center mt-4 absolute top-[-4px] right-3">
//           <div
//             className={`w-[20px] h-[20px] rounded cursor-pointer flex items-center justify-center ${
//               checkboxState === "selected"
//                 ? "bg-[#FEBA06] bg-[#FEBA06]"
//                 : checkboxState === "minus"
//                 ? "border-[#FEBA06] bg-transparent"
//                 : "border-[#FEBA06] bg-transparent"
//             } border-2 border-[#FEBA06]`}
//             onClick={() => handleCheckboxClick()}
//           >
//             {checkboxState === "selected" && (
//               <span className="text-[#000] font-bold">
//                 <FaCheck />
//               </span>
//             )}
//             {checkboxState === "minus" && (
//               <span className="text-[#FEBA06] font-bold">
//                 <FaMinus />
//               </span>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Card;

// Card backup
import { useState } from "react";
import { FaMinus } from "react-icons/fa6";
import { FaCheck } from "react-icons/fa6";
import CalvinLogo from "../../../assets/Images/Calvin-Group-Logo.svg";
import RightIcon from "../../../assets/Images/rightIcon.svg";
import MachineImg from "../../../assets/Images/machineImg.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { currencyFormat, detailPageURL, logoutFun } from "../../../utils/helper";
import NoImgIcon from "../../../assets/png/no-image-icon.png";
import Icon from "../../icon/Icon";
import { addWatchList } from "../../../services/vizyBilityServices";
import { toast } from "react-toastify";
import { useMsal } from "@azure/msal-react";
import { DarkLogo } from "../../../assets/images";

const Card = ({ data, listCard, isSearch }) => {
  const { instance, accounts } = useMsal();
  const [cardLoading, setCardLoading] = useState(false);
  const Logout = localStorage.getItem("getAzureUserData") || localStorage.getItem("azuretoken");
  const azureUserInfo = localStorage.getItem("getAzureUserData")
    ? JSON.parse(localStorage.getItem("getAzureUserData") || {})
    : null;
  const [watchList, setWatchList] = useState(data?.is_active_watchlist || false);
  const { state } = useLocation();
  const navigate = useNavigate();
  // State for the custom checkbox
  const [checkboxState, setCheckboxState] = useState("not-selected");

  // Handle checkbox click to cycle through states
  const handleCheckboxClick = () => {
    setCheckboxState((prevState) => {
      if (prevState === "not-selected") return "selected";
      if (prevState === "selected") return "minus";
      return "not-selected";
    });
  };
  const handleOnPressCall = () => {
    if (data?.dealer?.contact_user?.phone) {
      return `callto:${data?.dealer?.contact_user?.phone}`;
    } else if (data?.dealer?.contact_user?.email) {
      return `mailto:${data?.dealer?.contact_user?.email}`;
    } else {
      return "javascript:void(0)";
    }
  };
  const Rpath = detailPageURL(data);

  const handelWatchList = () => {
    setCardLoading(true);
    let payload = {
      assetId: data?.id,
      assetAdvertisementId: data?.assetAdvertisementId,
      contactId: azureUserInfo?.ContactId,
    };
    if (watchList) {
      payload = {
        ...payload,
        active: false,
      };
    } else {
      payload = {
        ...payload,
        active: true,
      };
    }

    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    addWatchList(payload, header, instance, accounts)
      .then((res) => {
        setCardLoading(false);
        setWatchList(!watchList);
        if (watchList) {
          toast.success("Successfully removed from watchlist!");
        } else {
          toast.success("Successfully added to watchlist!");
        }
      })
      .catch((err) => {
        setCardLoading(false);
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          toast.error("you are logged out, login again to add machines to watchlist.");
          logoutFun(instance);
        } else {
          toast.error(err?.data);
        }
      });
  };
  return (
    <>
      <div className="shadow-xl relative group flex flex-col h-full">
        <div onClick={() => navigate(Rpath, { state: { ...state, assetAdvertisementId: data?.assetAdvertisementId } })} className="cursor-pointer h-[250px]">
          <img
            src={data?.primary_image.url || NoImgIcon}
            alt="Machine"
            className="object-cover w-full rounded-t-lg h-full"
          />
        </div>

        <div className="flex flex-col justify-between flex-grow">
          <div className="p-[10px]">
            <div
              className="text-[#161412] text-[20px] font-bold cursor-pointer break-words whitespace-normal"
              onClick={() => navigate(Rpath, { state: { ...state, assetAdvertisementId: data?.assetAdvertisementId } })}
            >
              {data?.year} {data?.model?.manufacturer?.name} {data?.model?.number}
            </div>
            <div className="text-[#161412] text-[14px] font-normal break-words">{data?.machine_type?.name}</div>
            <div className="text-[#161412] text-[14px] font-medium">
              {data?.meter_reading ? data?.meter_reading : "N/A"}{" "}
              {data?.meter_reading_unit ? data?.meter_reading_unit : "Hours"}
            </div>
          </div>

          <div>
            <div className="mt-[10px] md:mt-[40px] text-center sm:text-end px-[10px]">
              <div className="text-[#161412] text-[20px] md:text-[30px] font-bold">
                {data?.advertised_price?.fractional != 0 ? (
                  <>
                    {data?.advertised_price?.currency?.symbol}
                    {currencyFormat(Number(data?.advertised_price?.fractional))}
                  </>
                ) : (
                  <a
                    href={handleOnPressCall()}
                    className="bg-[#FEBA06] py-[4px] text-[#161412] text-[20px] md:text-[25px] px-2 rounded disable:hover  "
                  >
                    Call for Pricing
                  </a>
                )}
              </div>

              {!isSearch ? (
                <></>
              ) : (
                <div className="flex items-center justify-end my-[10px]">
                  {data?.advertising_type?.trim().toLowerCase() == "consignment" ? (
                    <div>
                      <img src={DarkLogo} alt="Calvin Logo" className="max-h-[31px]" />
                    </div>
                  ) : data?.company_info?.logo?.url ? (
                    <div>
                      <img src={data?.company_info?.logo?.url} alt="Calvin Logo" className="max-h-[41px]" />
                    </div>
                  ) : null}
                </div>
              )}
            </div>
            <div
              className={`flex ${
                data?.advertising_type?.trim().toLowerCase() == "consignment"
                  ? "justify-between"
                  : data?.company_info?.logo?.url
                  ? "justify-between"
                  : "justify-end"
              } items-center px-[10px] pb-[10px] sm:flex-row flex-col gap-[10px]  `}
            >
              {isSearch ? (
                <div></div>
              ) : (
                <>
                  {data?.advertising_type?.trim().toLowerCase() == "consignment" ? (
                    <div>
                      <img src={DarkLogo} alt="Calvin Logo" className="max-h-[41px]" />
                    </div>
                  ) : data?.company_info?.logo?.url ? (
                    <div>
                      <img src={data?.company_info?.logo?.url} alt="Calvin Logo" className="max-h-[41px]" />
                    </div>
                  ) : null}
                </>
              )}

              <div className="flex flex-col items-center sm:items-end">
                <div className="text-[#161412] text-[16px] flex">
                  <img src={RightIcon} alt="Right Icon" className="mr-1" />
                  <b>
                    {data?.dealer?.name} {data?.dealer?.address ? `| ${data?.dealer?.address}` : null}
                  </b>
                </div>
                {data?.dealer?.contact_user?.phone ? (
                  <a
                    href={`callto:${data?.dealer?.contact_user?.phone}`}
                    className="text-[#161412] text-[16px] font-bold"
                  >
                    {data?.dealer?.contact_user?.phone}
                  </a>
                ) : null}
                {data?.dealer?.contact_user?.email ? (
                  <a
                    href={`mailto:${data?.dealer?.contact_user?.email}`}
                    className="text-[#161412] text-[16px] font-bold"
                  >
                    {data?.dealer?.contact_user?.email}
                  </a>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        {/* Custom Checkbox */}
        {/* <div className="flex justify-center mt-4 absolute top-[-4px] right-3">
          <div
            className={`w-[20px] h-[20px] rounded cursor-pointer flex items-center justify-center ${
              checkboxState === "selected"
                ? "bg-[#FEBA06]"
                : checkboxState === "minus"
                ? "border-[#FEBA06] bg-transparent"
                : "border-[#FEBA06] bg-transparent"
            } border-2 border-[#FEBA06]`}
            onClick={() => handleCheckboxClick()}
          >
            {checkboxState === "selected" && (
              <span className="text-[#000] font-bold">
                <FaCheck />
              </span>
            )}
            {checkboxState === "minus" && (
              <span className="text-[#FEBA06] font-bold">
                <FaMinus />
              </span>
            )}
          </div>
        </div> */}
        {Logout && (
          <div className="flex justify-center mt-4 absolute top-[-10px] left-1 opacity-100">
            {cardLoading ? (
              <div className="absolute top-0 left-0 w-[30px] h-[30px] border-2 border-[#feba06] border-dashed rounded-full animate-spin"></div>
            ) : (
              <Icon
                icon={"HeroHeart"}
                className={`text-2xl ${
                  watchList ? "fill-[#FEBA06]" : null
                } w-[30px] h-[30px] text-[#FEBA06] cursor-pointer`}
                onClick={() => handelWatchList()}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Card;
